import { deveExibirTermosDeUso, type UsuarioDosTermosDeUso } from './termosDeUso'

export const URL_DO_BORA = process.env.VUE_APP_BORA_URL || 'https://bora.pontotel.com.br'

export function obterDestinoDoSetup (usuario?: UsuarioDosTermosDeUso | null): 'termos' | 'bora' | null {
  if (
    usuario?.compMan.boraStatus !== 'AGUARDANDO_SETUP' ||
    usuario.roleGroup.kind !== 'all' ||
    usuario.ehDeSuporte ||
    usuario.email.includes('lar21@')
  ) {
    return null
  }

  return deveExibirTermosDeUso(usuario) ? 'termos' : 'bora'
}
